import { useEffect } from 'react';
import useCountDown from 'react-countdown-hook';
import { useFormContext } from 'react-hook-form';
import { TOO_MANY_REQUESTS_ERROR_TYPE, DEFAULT_ERROR_MESSAGE_COUNT_DOWN_START_TIME } from '../constansts/index.js';
import { splitRetryAfterAndErrorType } from '../helpers/utils.js';

function useClearErrorWithDelay(props) {
    const { inputName } = props;
    const { clearErrors, formState: { errors }, } = useFormContext();
    const error = errors[inputName];
    const isErrorExist = typeof error?.message === 'string';
    const [errorMessageShowTime, { start: startErrorMessageShowTimer, reset: resetErrorMessageShowTimer }] = useCountDown(0, 1000);
    useEffect(() => {
        if (!isErrorExist)
            return;
        if (typeof error.type === 'string' && error.type.includes(TOO_MANY_REQUESTS_ERROR_TYPE)) {
            const [_, timerMilliSeconds] = splitRetryAfterAndErrorType(error.type);
            startErrorMessageShowTimer(timerMilliSeconds || DEFAULT_ERROR_MESSAGE_COUNT_DOWN_START_TIME);
            return;
        }
        startErrorMessageShowTimer(DEFAULT_ERROR_MESSAGE_COUNT_DOWN_START_TIME);
    }, [error, isErrorExist, startErrorMessageShowTimer]);
    useEffect(() => {
        if (errorMessageShowTime === 0) {
            resetErrorMessageShowTimer();
            clearErrors(inputName);
        }
    }, [errorMessageShowTime, resetErrorMessageShowTimer, clearErrors, inputName]);
    return [errorMessageShowTime];
}

export { useClearErrorWithDelay };
//# sourceMappingURL=useClearErrorWithDelay.js.map
